export function formatters(val, format) {
    if (typeof (format) === 'function') {
      return format(val)
    } else return val
 }


// WEBPACK FOOTER //
// ./src/assets/script/filters.js